import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import { microServices } from 'network/apis/microservice/index'
import axiosInstance from 'network/apis/index'

export const placeBetHiLoService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'fast-games/hilo-game/place-bet', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

export const openCardHiLoService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'fast-games/hilo-game/open-card', data, {
    params: data,
    server: microServices.SERVICE_URL_1
  })
}

export const cashOutBetHiLoService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'fast-games/hilo-game/cash-out-bet', data, {
    params: data,
    server: microServices.SERVICE_URL_1
  })
}

export const myBetsHiLoService = (data) => {
  return axiosInstance(METHOD_TYPES.get, 'fast-games/hilo-game/my-bets', data, {
    params: data,
    server: microServices.SERVICE_URL_1
  })
}

export const getUnfinishedBetService = () => {
  return axiosInstance(METHOD_TYPES.get, 'fast-games/hilo-game/unfinished-bet', {
    params: {},
    server: microServices.SERVICE_URL_1
  })
}
